module.exports = __webpack_public_path__ + "img/AR.a6fad371.png";